module.exports = __webpack_public_path__ + "static/midbanner-f344bfe91c35813c508bf28c3a236d72.jpg";